// extracted by mini-css-extract-plugin
export var activityContainer = "_er-0";
export var typingIndicatorContainer = "_er-1";
export var typingIndicatorDot = "_er-2";
export var wave = "_er-3";